export default {
    timeFormat: function(value) {
        if (value) {
            return value.substring(0, 10);
        }
        return '';
    },
    flexTime: function(data) {
        if (data.ext1) {
            return data.ext1;
        }
        if (data.createTime) {
            return data.createTime.substring(0, 10);
        }
        return ''
    }
}



// WEBPACK FOOTER //
// ./src/filters/index.js